import * as Styles from './DefaultPaymentAction.styles';
import {
  Alert, Button, IconLoading, SelectField,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const DefaultPaymentAction = ({
  label,
  description,
  onClick,
  loading,
  selectedPaymentMethodOptions,
  selectPlaceholder = 'Selecciona la opción de pago',
  setSelectedPaymentMethodCode,
  multiplePaymentMethodsDescription,
  securePixTransation,
}) => {
  const handleClick = () => {
    onClick && onClick();
  };

  const handleSelect = useCallback((option) => {
    setSelectedPaymentMethodCode && setSelectedPaymentMethodCode(option.value);
  }, [
    setSelectedPaymentMethodCode,
  ]);

  const options = selectedPaymentMethodOptions && selectedPaymentMethodOptions.map(option => ({
    value: option.code,
    label: option.name,
  }));


  return (
    <Styles.Wrapper>
      {securePixTransation && (
        <Styles.AlertWrapper>
          <Alert
            width="full"
            customIcon="IconClock"
            title={securePixTransation}
          />
        </Styles.AlertWrapper>
      )}

      {selectedPaymentMethodOptions && (
        <Styles.SelectWrapper>
          <SelectField
            options={options}
            onClickSelect={e => handleSelect(e)}
            placeholder={selectPlaceholder}
          />
        </Styles.SelectWrapper>
      )}

      <Styles.ButtonWrapper>
        <Button
          label={loading ? <IconLoading /> : label}
          onClick={handleClick}
          size="medium2"
          disabled={loading}
        />
      </Styles.ButtonWrapper>

      <Styles.Description>
        {selectedPaymentMethodOptions
          ? multiplePaymentMethodsDescription
          : description}
      </Styles.Description>
    </Styles.Wrapper>
  );
};

DefaultPaymentAction.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  selectedPaymentMethodOptions: PropTypes.array,
  setSelectedPaymentMethodCode: PropTypes.func,
  multiplePaymentMethodsDescription: PropTypes.string,
  selectPlaceholder: PropTypes.string,
};

export default DefaultPaymentAction;
